import { ADD_OBSERVATION, CLEAR_OBSERVATION } from '../../mutation-types';

const actions = {
  clearObservation({ commit }, protocol) {
    commit(CLEAR_OBSERVATION, protocol);
  },

  newObservation({ commit }, { observation, protocol }) {
    commit(ADD_OBSERVATION, { observation, protocol });
  },
};

export default actions;
